import SyncRepository from './sync'

/* global $ SyncRepository */
$(() => {
  SyncRepository($('.js_sync-repository'))
})
